import React, { useContext, useEffect, useState, useCallback, useRef, useMemo } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import WinToolbar from "@/layout/WinToolbar";
import { Badge, Popover, Tag, Tooltip } from "antd";
import config, { ConfigEnum } from "@/config/config";
import GlobalSearch from "@/components/GlobalSearch";
import AddPopover from "@/components/GlobalSearch/AddPopover";
import bus from "@/utils/bus";
import { TopUpgradeTipTag } from "@/components/Tags";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import { FocusSDK, formatPercent, isFocusEnv } from "@/utils";
import ChatState from "@/types/chat/State";
import axios from "axios";
import { changeEgovUrl } from "@/utils/tools";
import BtnAiChat from "@/baseComponents/Chat/BtnAIChat";
import IconFont from "@/components/icon";
import "./RightContent.less";
import WanSvg from "@/assets/newsvg/wanzhuan.svg";


function RightContent({
  children,
  upgradeState,
  clientConfig,
  updateUpgradeVisable,
  currentEmployee,
  themes
}: { children?: any; updateUpgradeVisable: Function; currentEmployee: any } & UserState) {
  const { isDesktop, appRuntimeEnv, authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const [hasNewShortVideos, setHasNewShortVideos] = useState(0);
  const [visible, setVisible] = useState(false);
  // const winTool = isDesktop && appRuntimeEnv.platform === 'WINDOWS' ? <WinToolbar /> : null;
  // const winTool = isDesktop ? <WinToolbar /> : null;
  const winTool = <WinToolbar />;
  let conut = 0;
  const [withBtnPopover, setWithBtnPopover] = useState<boolean>(true);

  const fetchWanZhuanUpdateTime = useCallback(async () => {
    const wanZhuanMetaUrl = `https://oss.${changeEgovUrl(
      "jzb.beijing.gov.cn"
    )}/focus-desktop/guide/data/short-videos.meta.json`;
    const { data, status } = await axios({
      url: `${wanZhuanMetaUrl}?v=${Date.now()}`
    });
    if (status === 200) {
      return data.publishTime;
    }
    return 0;
  }, []);
  useEffect(() => {
    const hasNewVideos = async function () {
      const time = await fetchWanZhuanUpdateTime();
      const prevTime = localStorage.getItem("wanzhuanjingban_publish_time");
      if (prevTime !== String(time)) {
        setHasNewShortVideos(1);
      }
    };
    hasNewVideos();
    return () => {};
  }, [fetchWanZhuanUpdateTime]);

  useEffect(() => {
    bus.on("hideGlobalSearchModel", () => {
      setWithBtnPopover(true);
    });
    bus.on("showGlobalSearchModel", () => {
      setWithBtnPopover(false);
    });
    return () => {
      bus.off("showGlobalSearchModel");
      bus.off("hideGlobalSearchModel");
    };
  }, []);

  const isLLMAI = useMemo(() => {
    return (clientConfig?.llmAI || 0) === 1 && isFocusEnv();
  }, [clientConfig.llmAI, appRuntimeEnv]);

  const jumpWanzhuan = useCallback(() => {
    setHasNewShortVideos(0);
    fetchWanZhuanUpdateTime().then((res) => {
      localStorage.setItem("wanzhuanjingban_publish_time", res);
    });
    const url =
      appRuntimeEnv.key === "prod"
        ? changeEgovUrl("https://jzb.beijing.gov.cn/guide/#/short-video")
        : "https://jzb.beijing.gov.cn/oss/focus-desktop/jingzhiban/test/index.html#/short-video";
    window.open(url);
  }, [appRuntimeEnv.key, fetchWanZhuanUpdateTime]);

  const showWanZhuanEntry = useMemo(() => {
    // return false;
    return currentEmployee?.teamId === appRuntimeEnv.bjwpConfig.teamId
      ? false
      : ["mebj", "jgswy", "mebjJZB"].includes(appRuntimeEnv.runtimeConfig.key);
  }, [appRuntimeEnv, currentEmployee?.teamId]);
  // 下载提示状态
  const upgradeTipState = useMemo(() => {
    const { type, data = {} } = upgradeState?.upgradeData || {};
    const { percent } = data;
    const { backgroundDownload } = upgradeState;
    const color = !backgroundDownload
      ? "#DC011A"
      : type === "updateDownloading"
      ? "#1686FF"
      : type === "error"
      ? "#ED6A0C"
      : type === "updateDownloaded"
      ? "#3CBA81"
      : "#DC011A";
    return (
      <Tag
        style={{
          color
        }}
        className="upgradTag"
        onClick={() => {
          updateUpgradeVisable?.({
            visible: true
          });
        }}
      >
        {!backgroundDownload ? (
          <>
            <IconFont type="iconxinban" />
            有新版
          </>
        ) : type === "updateDownloading" ? (
          <>
            <IconFont type="iconxiazai" />
            {`${formatPercent(percent)}下载中`}
          </>
        ) : type === "updateDownloaded" ? (
          <>
            <IconFont type="iconchenggong" />
            下载完成 点击安装
          </>
        ) : type === "error" ? (
          <>
            <IconFont type="iconshibai" />
            下载失败 点击重试
          </>
        ) : (
          <>
            <IconFont type="iconxinban" />
            有新版
          </>
        )}
      </Tag>
    );
  }, [updateUpgradeVisable, upgradeState?.upgradeData, upgradeState.backgroundDownload]);
  const appName =
    "玩转" + (window as any)?._BTS_CONFIG?.REACT_APP_NAME || process.env.REACT_APP_NAME || "京办";

  // 玩转京办浮层
  const playIconContentPop = useMemo(() => {
    return (
      <div className="pop-wrap">
        <span className="icon" />
        <div className="right">
          <div className="title">玩转京办</div>
          <div className="text">欢迎来到视频专区，您将获得细致的功能讲解与应用介绍！</div>
        </div>
      </div>
    );
  }, []);

  return (
    <div className="rightSide">
      {config[ConfigEnum.TOP_BAR_ENABLE] && (
        <div className="topBar">
          {/* {winTool && <div style={{ width: 120 }} />}
          <div style={{ flex: 0.2 }} /> */}
          <div className="topBar-left" />
          <div className="Global-search">
            <div className="chat-left-header">
              {upgradeState?.show && upgradeTipState}
              {authInfo && <GlobalSearch />}
              {!isLLMAI && authInfo && withBtnPopover && <AddPopover />}
            </div>
          </div>
          <div className="topBar-right">
            <div className="chat-header-ext chat-left-header">
              {authInfo && isLLMAI && withBtnPopover && (
                <AddPopover />
              )}
              {showWanZhuanEntry && (
                <Popover
                  content={playIconContentPop}
                  trigger="hover"
                  overlayClassName="play-icon-pop-content"
                >
                  <Badge className="wanzhuan-wrap item" count={hasNewShortVideos} dot>
                    <div
                      clstag="pageclick|keycount|xtbg_add_home_1637657110163|99"
                      onClick={jumpWanzhuan}
                    >
                      <WanSvg />
                    </div>
                  </Badge>
                </Popover>
              )}
              {authInfo && isLLMAI && (
                <>
                  <span className={`line ${themes}`} />
                  <BtnAiChat className={`${themes}theme`} />
                </>
              )}
              {/* <Badge className="wanzhuan-wrap item">
                <div onClick={() => setVisible(true)}><IconFont type="iconic_pc_copy" className="icon" /></div>
              </Badge> */}
            </div>
            {winTool}
          </div>
          {/* <div style={{ flex: 0.5 }} /> */}
        </div>
      )}
      <div className="rightSide newRight">
        <div className="appContent">{children}</div>
        {visible && (
          <div className="fixRight">
            <span onClick={() => setVisible(false)}>关闭</span>
          </div>
        )}
      </div>
    </div>
  );
}

function mapStateToProps({ user, chat }: { user: UserState; chat: ChatState }) {
  const { upgradeState, clientConfig, themes } = user;
  const { currentEmployee } = chat;
  return { upgradeState, clientConfig, currentEmployee, themes };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateUpgradeVisable(data: any) {
      dispatch({ type: "user/updateUpgradeVisable", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RightContent);
